<template>
    <svg
        width="18"
        height="14"
        viewBox="0 0 18 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M17.177 7.17767C17.177 7.17772 17.1769 7.17776 17.1769 7.1778L11.1771 13.1776L11.1709 13.1838L11.1649 13.1903C11.142 13.2148 11.1144 13.2345 11.0837 13.2482C11.053 13.2619 11.0199 13.2692 10.9864 13.2698C10.9528 13.2704 10.9194 13.2642 10.8883 13.2516C10.8572 13.2391 10.8289 13.2204 10.8052 13.1966C10.7814 13.1729 10.7627 13.1446 10.7501 13.1135C10.7376 13.0823 10.7314 13.049 10.732 13.0154C10.7326 12.9819 10.7399 12.9488 10.7536 12.9181C10.7673 12.8874 10.787 12.8598 10.8115 12.8369L10.818 12.8309L10.8242 12.8247L15.5442 8.10468L16.3978 7.25113H15.1907H1.00066C0.934357 7.25113 0.870766 7.22479 0.823883 7.17791C0.776999 7.13102 0.75066 7.06743 0.75066 7.00113C0.75066 6.93483 0.776999 6.87124 0.823883 6.82435C0.870766 6.77747 0.934357 6.75113 1.00066 6.75113H15.1907H16.3978L15.5442 5.89758L10.8242 1.17758L10.818 1.17134L10.8115 1.16533C10.787 1.14244 10.7673 1.11484 10.7536 1.08417C10.7399 1.0535 10.7326 1.0204 10.732 0.986832C10.7314 0.953264 10.7376 0.919921 10.7501 0.888792C10.7627 0.857663 10.7814 0.829385 10.8052 0.805645C10.8289 0.781904 10.8572 0.76319 10.8883 0.750617C10.9195 0.738043 10.9528 0.731869 10.9864 0.732461C11.0199 0.733053 11.053 0.7404 11.0837 0.754064C11.1144 0.767728 11.142 0.787428 11.1649 0.811991L11.1709 0.818445L11.1771 0.824683L17.1769 6.82446C17.1769 6.8245 17.177 6.82454 17.177 6.82459C17.2237 6.87145 17.25 6.93494 17.25 7.00113C17.25 7.06732 17.2237 7.13081 17.177 7.17767Z"
            fill="#ED1C24"
            :stroke="color"
        />
    </svg>
</template>

<script>
export default {
    name: "ButtonArroRightIcon",
    props: {
        color: {
            type: String,
            default: "#7a7a7a",
        },
    },
};
</script>
